// subcomponents/one_time_income/DeleteConfirmModal.js
import {Modal} from "antd";
import {ExclamationCircleOutlined} from "@ant-design/icons";

const DeleteConfirmModal = ({visible, record, onClose, onConfirm}) => {
    return (
        <Modal
            title={
                <span>
                    <ExclamationCircleOutlined style={{color: '#faad14', marginRight: 8}}/>
                    Подтверждение удаления
                </span>
            }
            open={visible}
            onOk={onConfirm}
            onCancel={onClose}
            okText="Удалить"
            cancelText="Отмена"
            okButtonProps={{danger: true}}
        >
            <p>Вы уверены, что хотите удалить запись?</p>
            {record && (
                <p>
                    <strong>Наименование:</strong> {record.name}<br/>
                    <strong>Сумма:</strong> {record.cost?.toFixed(2)} €
                </p>
            )}
        </Modal>
    );
};

export default DeleteConfirmModal;